export default {
    UnregisteredItemChangedEvent: {
        datapoint: { name: 'ExtTriggerUnregisteredItemChangedEvent' },
    },
};
